// Handles YouTube API

export const loadScript = () => {
  if (!document.querySelector("#js-youtube-iframe-api")) {
    // If not, load the script asynchronously
    const tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    tag.id = "js-youtube-iframe-api";

    const firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }
};

export const createPlayer = (playerId, videoId, cb, autoplay) => {
  return new window.YT.Player(playerId, {
    videoId,
    host: "https://www.youtube-nocookie.com",
    width: "auto",
    height: "auto",
    playerVars: {
      autoplay: autoplay === "true" ? 1 : 0,
    },
    events: {
      onReady: (event) => {
        event.target.mute(); // This will mute the video on load
        cb(event);
      },
    },
  });
};
